import { AnalysisServiceModel } from "e.sic-platform.webclient/src/services/analysis/AnalysisService";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import { AppStorageModel } from "e.sic-platform.webclient/src/services/app/AppStorage";
import { ConversionServiceModel } from "e.sic-platform.webclient/src/services/conversion/VideoConversionService";
import { errorHandler } from "e.sic-platform.webclient/src/services/error-handler/ErrorHandlerService";
import { OcrServiceModel } from "e.sic-platform.webclient/src/services/ocr/OcrService";
import { SegmentationServiceModel } from "e.sic-platform.webclient/src/services/segmentation/SegmentationService";
import { ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";
import Language from "e.sic-platform.webclient/src/services/translation/language";
import { uploadFilesService } from "e.sic-platform.webclient/src/services/upload/UploadFilesService";

export const segmentationApp = AppStorageModel.create(
    {
        services: {videoSegmentation: SegmentationServiceModel.create({activityType: ActivityTypes.HighlightDetection, language: Language.english})},
        route: "/video-segmentation",
        activityType: [ActivityTypes.HighlightDetection],
        descriptionkey: "videoSegmentation.description",
        image: "/images/video-segmentation.png",
        titleKey: "general.apps.video-segmentation.title"
    },
    {
        api: api,
        uploadFilesService: uploadFilesService,
        errorHandler: errorHandler,
        creditBalanceStorage: creditBalanceStorage
    }
)

export const analysisApp = AppStorageModel.create(
    {
        services: {videoAnalysis: AnalysisServiceModel.create({activityType: ActivityTypes.VideoAnalysis, language: Language.english})},
        route: "/video-analysis",
        activityType: [ActivityTypes.VideoAnalysis],
        descriptionkey: "videoAnalysis.description",
        image: "/images/video-analysis.png",
        titleKey: "general.apps.video-analysis.title"
    },
    {
        api: api,
        uploadFilesService: uploadFilesService,
        errorHandler: errorHandler,
        creditBalanceStorage: creditBalanceStorage
    }
)

export const conversionApp = AppStorageModel.create(
    {
        services: {videoConversion: ConversionServiceModel.create({activityType: ActivityTypes.VideoConversion})},
        route: "/video-conversion",
        activityType: [ActivityTypes.VideoConversion],
        descriptionkey: "videoConversion.description",
        image: "/images/video-conversion.png",
        titleKey: "general.apps.video-conversion.title"
    }, 
    {
        api: api,
        uploadFilesService: uploadFilesService,
        creditBalanceStorage: creditBalanceStorage
    }
);

export const ocrApp = AppStorageModel.create(
    {
        services: {ocrService: OcrServiceModel.create({activityType: ActivityTypes.VideoOcr})},
        route: "/inspection-insights",
        activityType: [ActivityTypes.VideoOcr],
        descriptionkey: "ocrService.description",
        image: "/images/ocr-service.png",
        titleKey: "general.apps.ocr-service.title"
    },
    {
        api: api,
        uploadFilesService: uploadFilesService,
        creditBalanceStorage: creditBalanceStorage
    }
)

export const analysisAndSegmentationApp = AppStorageModel.create(
    {
        services: {
            videoAnalysis: AnalysisServiceModel.create({activityType: ActivityTypes.VideoAnalysis, language: Language.english}),
            videoSegmentation: SegmentationServiceModel.create({activityType: ActivityTypes.HighlightDetection, language: Language.english})
        },
        route: "/analysis-and-segmentation",
        activityType: [ActivityTypes.VideoAnalysis, ActivityTypes.HighlightDetection],
        descriptionkey: "analysis-and-segmentation.description",
        titleKey: "general.apps.analysis-and-segmentation.title",
        image: "/images/analysis-and-segmentation.png"
    },
    {
        api: api,
        uploadFilesService: uploadFilesService,
        errorHandler: errorHandler,
        creditBalanceStorage: creditBalanceStorage
    }
)